import { TextField } from "@mui/material";
import React, { useState } from "react";

export const TextareaCustom = (props) => {

    const onTrigger = (event) => {

        if (props.required) {
            const value = event.target.value;
            (value.length < 4) ? setOnError(true) : setOnError(false);
        }

        props.parentCallback(event);
    };

    const [value] = useState("");
    const [OnError, setOnError] = useState(false);

    return (
        <TextField
            fullWidth
            defaultValue={value}
            error={OnError}
            id={props.name}
            label={props.label}
            maxRows={12}
            minRows={4}
            multiline
            name={props.name}
            onChange={onTrigger}
            required={props.required}
            helperText={props.helperText}
            variant={props.variant}

            inputProps={ props.inputProps }
        />
    );
};
